import React, { useRef, useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Typography, Form, Input, Button, Row, Col, DatePicker, Select, message, Spin } from 'antd';
import { AlphaNumInput } from 'shared_components/pattern_input';
import moment from 'moment';
//lov api
import {fetchAgentsListAPI, fetchCustomersListAPI} from 'services/shared/fetchLovList';
//invoice api
import { searchInvoiceAPI } from 'services/invoice/invoice'
import { UserAccessContext } from 'context/userAccess';

const {Text} = Typography;
const {RangePicker} = DatePicker;
const { Option } = Select;

function SearchForm({onFinish, onSearchStart, onSearchEnd}) {
	const { userAccess } = useContext(UserAccessContext);

    const navigate = useHistory();
    const formRef = useRef();
    const [ loading, setLoading ] = useState(false);
    const [ searchLoading, setSearchLoading ] = useState(false);

    const [agentsList, setAgentsList] = useState([]);
    const [customersList, setCustomersList] = useState([]);

    async function getLOVList(){
        try{
            const agents = await fetchAgentsListAPI();
            const customers = await fetchCustomersListAPI();

            setAgentsList(agents);
            setCustomersList(customers);
        }catch(error) {
            console.log("error", error);
        }
    };

    useEffect( ()=> {
        function fetchData() {
            getLOVList();
        }
        setLoading(true);
        fetchData();
        setLoading(false);

    }, []);

    //agents LOV
    const agentsOptions = agentsList.map((item, index) => {
        return(
            <Option key={index} value={item.agent_id}>{item.agent}</Option>
        );
    })

    //customers LOV
    const customersOptions = customersList.map((item, index) => {
        return(
            <Option key={index} value={item.customer_id}>{item.customer}</Option>
        );
    })

    async function handleSubmit(formValues){
        try{
            setSearchLoading(true);
            if(onSearchStart) onSearchStart();
            const result = await searchInvoiceAPI(formValues)
            onFinish(result);
        
            if(result.length <= 0){
                message.info('No results found');
            }
        }catch(error) {
            console.log("error", error);
        } finally {
            setSearchLoading(false);
            if(onSearchEnd) onSearchEnd();
        }
    }

    function handleFocusInvNo(){
        // @ts-ignore
        const { setFieldsValue } = formRef.current;
        setFieldsValue({ invoice_date: [], agent: [], customer: [] })
    }

    function handleFocusInput(){
        // @ts-ignore
        const { setFieldsValue } = formRef.current;
        setFieldsValue({ invoice_no: '' })
    }

    function clearSearch(){
        // @ts-ignore
        const { setFieldsValue } = formRef.current;
        setFieldsValue({ invoice_no: '', invoice_date: [], agent: [], customer: [] })
    }

    const handleInvDateOnChange = (date, dateString) => {
        // setDateFormat(dateString);
    }

    const disabledDate = (current) => {
        // Can not select future dates
        return current > moment().endOf('day');
    };
    
    return (
        <div>
            <Form layout='vertical'
                onFinish={handleSubmit}
                ref={formRef}
            >
            {/* <Row gutter={[8, 1]} align='bottom'> */}
                {/* invoice fields */}
                <Row gutter={[8, 1]} justify='space-around'>
                    <Col className="gutter-row" span={4}>
                        <Form.Item
                            label='INVOICE NO.'
                            name="invoice_no"
                        >
                            <AlphaNumInput placeholder='INVOICE NO.' 
                                className='inv-input-uppercase'
                                onFocus={handleFocusInvNo}
                                maxLength={50}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                        <div style={{ marginLeft:5 ,marginRight:10, marginTop: 27 }}>
                            {/* <div style={{marginTop: 27}}> */}
                            <Text strong className="inv-filler-str">OR</Text>
                        </div>
                    </Col>
                    <Col className="gutter-row" span={5}>
                        <Form.Item
                            label='INVOICE DATE'
                            name="invoice_date"
                        >
                            {/* <Input placeholder='INVOICE DATE'></Input> */}
                            {/* @ts-ignore */}
                            <RangePicker 
                                format={"MM-DD-YYYY"} 
                                onChange={handleInvDateOnChange} 
                                onFocus={handleFocusInput} 
                                disabledDate={disabledDate} 
                            />
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={5}>
                        <Form.Item
                            label='AGENT'
                            name="agent"
                        >
                            <Select placeholder="AGENT"
                                showSearch	
                                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                onFocus={handleFocusInput}
                            >
                                {agentsOptions}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={9}>
                        <Form.Item
                            label='CUSTOMER'
                            name="customer"
                        >
                            <Select placeholder="CUSTOMER"
                                showSearch	
                                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                onFocus={handleFocusInput}
                            >
                                {customersOptions}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {/* buttons */}
                <Row gutter={[8, 1]} justify='end'>
                    <Col>
                        <Form.Item shouldUpdate>
                            {
                                ({ getFieldsValue }) => {
                                    const { invoice_no, invoice_date, agent, customer } = getFieldsValue();
                                    // Allow search with any parameter, including when no date is specified (to show all dates)
                                    const disabled = !( invoice_no || agent || customer || 
                                        (invoice_date && Array.isArray(invoice_date) && invoice_date.length > 0) );

                                    return(
                                        <Row>
                                            <Button 
                                            className="login-form-button inv-button"
                                                type="primary" 
                                                htmlType='submit'
                                                disabled={disabled || searchLoading}
                                                loading={searchLoading}
                                            >
                                                SEARCH
                                            </Button>
                                            <Button 
                                                className="form-button inv-button-right"
                                                onClick={clearSearch}
                                            >
                                                CLEAR
                                            </Button>
                                        </Row>
                                    )
                                }
                            }
                        </Form.Item>
                    </Col>
                </Row>
                {(userAccess['invoices'].create === 'TRUE')
                ?   <Row gutter={[8, 1]} justify='end' align='bottom'>
                        <Col className="gutter-row">
                            <Form.Item>
                                <Button 
                                // className="login-form-button inv-button-right"
                                    style={{ marginBottom: -5}}
                                    type="primary" 
                                    onClick={() => navigate.push('/invoice/data_entry/?status=new')}
                                >
                                    ADD INVOICE
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
                }
            </Form>
        </div>
    );
}

export default SearchForm;